import {
  REQUEST_CONTENT_MENU,
  REQUEST_CONTENT_MENU_SUCCESS,
  REQUEST_CONTENT_MENU_FAILED
} from "../actions/contentMenu";

export function contentMenu(state = { data: {} }, action) {
  switch (action.type) {
    case REQUEST_CONTENT_MENU:
      return state;
    case REQUEST_CONTENT_MENU_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data
        },
        error: null
      };
    case REQUEST_CONTENT_MENU_FAILED:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/contentMenu.js